export const DATA_ACCORDION_ITEM = 'data-accordion-item'
export const ARIA_CONTROLS = '[data-control]'

export const getAccordionLevel = (element: any) => {
  let levelIndex = 1

  while (element.parentNode) {
    element = (element as HTMLDivElement).parentNode

    /* istanbul ignore else */
    if (element && element.getAttribute && element.getAttribute(DATA_ACCORDION_ITEM)) {
      levelIndex++
    }
  }

  return levelIndex
}

export const getParentByAttribute = (element: any, attribute: string) => {
  while (element.parentNode) {
    element = (element as HTMLDivElement).parentNode

    /* istanbul ignore else */
    if (element && element.getAttribute && element.getAttribute(attribute)) {
      return element
    }
  }

  return null
}

export const getParentHasNextSiblings = (element: any, attribute = '') => {
  while (element.parentNode) {
    element = (element as HTMLDivElement).parentNode

    /* istanbul ignore else */
    if (
      element &&
      element.getAttribute &&
      element.getAttribute(attribute) &&
      element?.nextElementSibling
    ) {
      return element
    }
  }

  return null
}

export const getAllSiblings = (
  elem: HTMLElement | ChildNode | null,
  filter?: (elem: any) => boolean,
): HTMLElement[] => {
  const sibs: HTMLElement[] = []

  elem = elem?.parentNode?.firstChild || null

  do {
    /* istanbul ignore else */
    if (elem?.nodeType === 3) {
      continue // text node
    }
    /* istanbul ignore else */
    if (!filter || filter(elem)) {
      sibs.push(elem as HTMLElement)
    }
  } while ((elem = elem?.nextSibling || null))

  return sibs
}

export const isValidTrigger = (item: HTMLElement) => {
  const parent = getParentByAttribute(item, DATA_ACCORDION_ITEM)

  /* istanbul ignore else */
  if (parent) {
    const panel = parent.querySelector('[data-accordion-panel]')

    /* istanbul ignore else */
    if (panel && panel.getAttribute('data-state') === 'open') {
      return true
    }
  }

  return false
}

export const goToHome = (element: HTMLElement | null) => {
  /* istanbul ignore else */
  if (!element) {
    return
  }

  const siblingsHome = getAllSiblings(element)

  /* istanbul ignore else */
  if (siblingsHome?.length > 0) {
    const firstButton = siblingsHome[0].querySelector(ARIA_CONTROLS) as HTMLElement
    firstButton?.focus()
  }
}

export const goToEnd = (element: HTMLElement | null) => {
  /* istanbul ignore else */
  if (!element) {
    return
  }

  const siblingsEnd = getAllSiblings(element)

  /* istanbul ignore else */
  if (siblingsEnd.length > 0) {
    const lastButton = siblingsEnd[siblingsEnd.length - 1].querySelector(
      ARIA_CONTROLS,
    ) as HTMLElement
    lastButton?.focus()
  }
}

export const goToPreviousItem = (target: HTMLElement | null, currentTarget: HTMLElement | null) => {
  const prev = getParentByAttribute(target, DATA_ACCORDION_ITEM)?.previousElementSibling

  if (prev) {
    const [lastItem] = [...prev.querySelectorAll('[data-accordion-item]')]
      .slice()
      .reverse()
      .filter((item) => isValidTrigger(item))

    if (lastItem) {
      lastItem.querySelector(ARIA_CONTROLS)?.focus()
      return
    }

    prev.querySelector(ARIA_CONTROLS)?.focus()
    return
  }

  const lastTarget = getParentByAttribute(currentTarget, DATA_ACCORDION_ITEM)

  if (lastTarget) {
    lastTarget?.querySelector(ARIA_CONTROLS)?.focus()
    return
  }

  if (!lastTarget) {
    const accordion = getParentByAttribute(currentTarget, 'data-accordion')
    const [lastItem] = [...accordion.querySelectorAll('[data-accordion-item]')].slice().reverse()

    const lastItemParent = getParentByAttribute(lastItem, DATA_ACCORDION_ITEM)

    if (
      (lastItemParent && lastItemParent.getAttribute('data-state') === 'open') ||
      !lastItemParent
    ) {
      lastItem?.querySelector(ARIA_CONTROLS).focus()
    } else {
      if (lastItemParent) {
        lastItemParent?.querySelector(ARIA_CONTROLS).focus()
      }
    }
  }
}

export const goToNextItem = (target: HTMLElement | null, currentTarget: HTMLElement | null) => {
  const child = getParentByAttribute(target, DATA_ACCORDION_ITEM)?.querySelector(
    '[data-accordion-item]',
  )

  if (child && isValidTrigger(child)) {
    child.querySelector(ARIA_CONTROLS)?.focus()
    return
  }

  const next = getParentByAttribute(target, DATA_ACCORDION_ITEM)?.nextElementSibling

  /* istanbul ignore else */
  if (next) {
    next.querySelector(ARIA_CONTROLS)?.focus()
    return
  }

  /* istanbul ignore else */
  if (!next) {
    const current = getParentByAttribute(target, DATA_ACCORDION_ITEM)
    const parent = current && getParentHasNextSiblings(current, DATA_ACCORDION_ITEM)

    /* istanbul ignore else */
    if (parent) {
      parent?.nextElementSibling.querySelector(ARIA_CONTROLS)?.focus()
      return
    } else {
      const accordion = getParentByAttribute(current, 'data-accordion')
      accordion?.querySelector(ARIA_CONTROLS)?.focus()
    }
  }
}
